import axios from 'axios';
import './axiosInterceptor';
export const AUTHENTICATION = process.env.VUE_APP_URLAUTHENTICATION;
export const Refresh = {
     //refrescar token
     getRefreshToken() {
        return  axios.get(AUTHENTICATION+"/adm/refresh-token")
    },
}